module.exports = __webpack_public_path__ + "media/images/logo_black-b89975a628d0c0a757e8dea541554cd2.png";